if(!customElements.get('search-form')) {
  customElements.define("search-form", class SearchForm extends HTMLElement {
    constructor() {
      super();

      this.searchBtn = this.querySelector("#mobSearch");
      this.searchForm = this.querySelector(".search__form");
      this.formOverlay = this.querySelector(".search__form-overlay");
      this.closeForm = this.querySelector("#closeSearch");

      this.init();
    }

    init() {
      this.searchBtn.addEventListener("click", this.openSearchform.bind(this));
      this.formOverlay.addEventListener("click", this.closeSearchform.bind(this));
      this.closeForm.addEventListener("click", this.closeSearchform.bind(this));
    }

    openSearchform() {
      this.searchForm.classList.add("search--open");
    }
    closeSearchform() {
      this.searchForm.classList.remove("search--open");
    }
  });
}
